var module = angular.module('components');
module.component('caSortTableDataHeader', {
    templateUrl: 'components/genericcomponents/sortingtabledataheader.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        orderBy: '=',
        reverse: '=',
        header: '<',
        valueName: '<',
    },
    controller: ['$q', '$scope', '$translate', controller]
});

function controller($q, $scope, $translate) {
    var vm = this;

    vm.changeSortOrder = changeSortOrder;
    vm.getTooltipText = getTooltipText;

    function changeSortOrder(){
        if(vm.orderBy === vm.valueName){
            if(vm.reverse){
                vm.orderBy = undefined;
                vm.reverse = undefined;
            }
            else{
                vm.reverse = true;
            }
        }
        else{
            vm.orderBy = vm.valueName;
            vm.reverse = false;
        }
    }

    function getTooltipText(){
        var text = "";

        if(vm.reverse === true && vm.orderBy === vm.valueName)
            text += $translate.instant('common.reset');
        else{
            text += $translate.instant('analysis.sort') + " ";
            
            text += vm.reverse === false && vm.orderBy === vm.valueName ? 
                        $translate.instant('analysis.sort.descending') : 
                        $translate.instant('analysis.sort.ascending')
        }

        return text;
    }
}
